import { Popover, Text } from '@medly-components/core';
import { DateRangeIcon } from '@medly-components/icons';
import { format } from 'date-fns';
import { type FC } from 'react';
import { DateRangePickerCalendar } from './DateRangePickerCalendar';
import { FlatDateRangePickerButton, FlatDateRangePickerWrapper } from './FlatDateRangePicker.styled';
import { FlatDateRangePickerProps } from './types';

export const FlatDateRangePicker: FC<FlatDateRangePickerProps> = props => {
    const { value, popoverPlacement } = props;

    return (
        <FlatDateRangePickerWrapper interactionType="click">
            <FlatDateRangePickerButton>
                <DateRangeIcon />
                <Text>
                    {`${value.startDate ? format(value.startDate, 'dd LLL yyy') : 'From'} 
                    - ${value.endDate ? format(value.endDate, 'dd LLL yyy') : 'To'}`}
                </Text>
            </FlatDateRangePickerButton>
            <Popover.Popup placement={popoverPlacement} distance="1rem" fullWidth>
                <DateRangePickerCalendar {...props} />
            </Popover.Popup>
        </FlatDateRangePickerWrapper>
    );
};

FlatDateRangePicker.displayName = 'FlatDateRangePicker';
